// extracted by mini-css-extract-plugin
export default {"search-button":"fOIjbTE0oqYApdC3yLvk","searchButton":"fOIjbTE0oqYApdC3yLvk"};